import { createVNode, mergeProps } from "vue";
export default {
  name: 'PenToolIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-pen-tool"
    }, { ...attrs
    }), [createVNode("path", {
      "d": "M12 19l7-7 3 3-7 7-3-3z"
    }), createVNode("path", {
      "d": "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
    }), createVNode("path", {
      "d": "M2 2l7.586 7.586"
    }), createVNode("circle", {
      "cx": "11",
      "cy": "11",
      "r": "2"
    })]);
  }

};